import { render } from "./retire.vue?vue&type=template&id=5814d572"
import script from "./retire.vue?vue&type=script&lang=js"
export * from "./retire.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__